// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClaimPickUpInfo_wrapper__3UZAi","header":"ClaimPickUpInfo_header__3k1aH"};